import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useEffect, useState, useRef } from "react";
import { CircularProgress } from "./CircularProgress";

export const UpdateDataPrompt = ({title = "New data available - click to update"}) => {
    const [timeLeft, setTimeLeft] = useState(null);
    const totalTimeRef = useRef(null);

    useEffect(() => {
        // Set random time between 10 seconds and 2 minutes (120 seconds)
        const randomSeconds = Math.floor(Math.random() * (120 - 10 + 1)) + 10;
        totalTimeRef.current = randomSeconds;
        setTimeLeft(randomSeconds);

        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    window.location.reload(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const getPercentage = () => {
        if (!timeLeft || !totalTimeRef.current) return 0;
        // Reverse: 0% at start (full time), 100% at end (no time)
        return ((totalTimeRef.current - timeLeft) / totalTimeRef.current) * 100;
    };

    return (

        <button
            onClick={() => window.location.reload(true)}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-[7px] px-4 rounded-lg shadow grow-on-hover"
        >
            <div className="flex items-center justify-between">
                <div className="mr-2"><ArrowPathIcon className="w-5 h-5" /></div>
                <div className="mr-3">{title}</div>
                <CircularProgress percentage={getPercentage()} displayValue={timeLeft} />
            </div>
        </button>

    )
}